import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { configSectionsInOut } from 'animations-lib';
import { DateFormatOptions } from '../../../../../utils/fieldconfig';
import { FieldConfigChangedControllerService } from '../../../data-fields/field-config-changed-controller.service';

@Component({
    selector: 'app-date-format',
    templateUrl: './date-format.component.html',
    styleUrls: ['./date-format.component.scss', '../field-options.component.scss'],
    animations: [configSectionsInOut],
    standalone: false
})
export class DateFormatComponent implements OnInit {
  @Input() set fieldOptions(dateFormatOptions: DateFormatOptions | undefined) {
    this.initFieldOptions(dateFormatOptions);
    this.hasChanged = false;
  }

  @Output() fieldOptionsChange = new EventEmitter<DateFormatOptions>();

  expanded = false;
  hasChanged = false;
  dateFormat = '';
  language = '';
  currentYear: number;

  constructor(private configChangedControllerService: FieldConfigChangedControllerService) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
    this.hasChanged = this.configChangedControllerService.get('DateFormatComponent');
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  clearDateFormat() {
    this.dateFormat = '';
    this.updateParent();
  }

  clearLanguage() {
    this.language = '';
    this.updateParent();
  }

  updateParent() {
    this.fieldOptionsChange.emit({
      dateFormat: this.dateFormat,
      language: this.language,
    });
    this.configChangedControllerService.update(DateFormatComponent.name, true);
    setTimeout(() => (this.hasChanged = true), 0);
  }

  private initFieldOptions(dateFormatOptions: DateFormatOptions | undefined) {
    if (dateFormatOptions) {
      this.dateFormat = dateFormatOptions.dateFormat;
      this.language = dateFormatOptions.language;
    }
  }
}
